import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const rejectSync = async () => {
  const url = `${API_URL}/items/sync`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (res.status === Status.BAD_REQUEST || res.ok === false) {
    throw new Error('Something went wrong whilst rejecting the sync');
  }
};
